/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { closelightbox } from "../../util/Functions";
import * as API from "../../http/api";
import * as MATERIAL from "@mui/material";
import * as ICONS from "@mui/icons-material";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Box, Tabs, Tab, FormControlLabel, Checkbox } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const LeadInfo = (props) => {
  const [zPos, setZPos] = useState(45)
  const [tab, setTab] = useState("verify");
  const [disabled, setDisabled] = useState(false);
  const [disablePhone, setDisablePhone] = useState(true);
  const [codePhone, setCodePhone] = useState("");
  const [token, setToken] = useState("");
  const [disableSendCode, setDisableSendCode] = useState(true);
  const [disableMail, setDisableMail] = useState(true);
  const [disableCurpRfc, setDisableCurpRfc] = useState(true);
  const [localityShipping, setLocalityShipping] = useState([]);
  const [localityInvoicing, setLocalityInvoicing] = useState([]);
  const [sameAddress, setSameAddress] = useState(false);

  const [send, setSend] = useState(false);
  const [validates, setValidates] = useState({
    phone: { validate: false, value: "", send: false },
    email: { validate: false, value: "" },
    curp: { validate: false, value: "" },
    rfc: { validate: false, value: "" },
  });
  const [form, setForm] = useState({
    general: { bcountry: "", bdate: "", bstate: "", email: "", gender: "", gname: "", lname: "", occupation: "", phone: "", populationid: "", slname: "", taxid: "" },
    address: {
      invoicing: { country: "", extnum: "", intnum: "", locality: "", state: "", street: "", town: "", zip: "" },
      shipping: { country: "", extnum: "", intnum: "", locality: "", state: "", street: "", town: "", zip: "" },
    },
  });

  const [identity, setIdentity] = useState({
    type: "",
    front_image: false,
    back_image: false,
    token_face_image: false,
  });

  useEffect(() => {
    if (!props.rolEdit) {
      setTab("general");
    }
    init();
  }, []);

  const init = () => {
    let f = form;

    if (props.contentModal.identity) {
      var identity = {
        type: "",
        front_image: false,
        back_image: false,
        token_face_image: false,
      };
      if (props.contentModal.identity.document_type === "INE") {
        identity.type = "INE";
        if (props.contentModal.identity.identity.front_image) {
          identity.front_image = true;
        }
        if (props.contentModal.identity.identity.back_image) {
          identity.back_image = true;
        }
        if (props.contentModal.identity.identity.token_face_image) {
          identity.token_face_image = true;
        }
      } else {
        identity.type = "PASAPORT";
        if (props.contentModal.identity.identity.front_image) {
          identity.front_image = true;
        }
        if (props.contentModal.identity.identity.token_face_image) {
          identity.token_face_image = true;
        }
      }
      setIdentity(identity);
    }

    if (props.contentModal.address) {
      let address = props.contentModal.address;
      if (address.invoicing) {
        let invoicing = address.invoicing;
        if (invoicing.country) {
          f.address.invoicing.country = invoicing.country;
        }
        if (invoicing.extnum) {
          f.address.invoicing.extnum = invoicing.extnum;
        }
        if (invoicing.intnum) {
          f.address.invoicing.intnum = invoicing.intnum;
        }
        if (invoicing.locality) {
          f.address.invoicing.locality = invoicing.locality;
        }
        if (invoicing.state) {
          f.address.invoicing.state = invoicing.state;
        }
        if (invoicing.street) {
          f.address.invoicing.street = invoicing.street;
        }
        if (invoicing.town) {
          f.address.invoicing.town = invoicing.town;
        }
        if (invoicing.zip) {
          f.address.invoicing.zip = invoicing.zip;
        }
      }

      if (address.shipping) {
        let shipping = address.shipping;
        if (shipping.country) {
          f.address.shipping.country = shipping.country;
        }
        if (shipping.extnum) {
          f.address.shipping.extnum = shipping.extnum;
        }
        if (shipping.intnum) {
          f.address.shipping.intnum = shipping.intnum;
        }
        if (shipping.locality) {
          f.address.shipping.locality = shipping.locality;
        }
        if (shipping.state) {
          f.address.shipping.state = shipping.state;
        }
        if (shipping.street) {
          f.address.shipping.street = shipping.street;
        }
        if (shipping.town) {
          f.address.shipping.town = shipping.town;
        }
        if (shipping.zip) {
          f.address.shipping.zip = shipping.zip;
        }
      }
    }

    if (props.contentModal.general) {
      let general = props.contentModal.general;
      if (general.bcountry) {
        f.general.bcountry = general.bcountry;
      }
      if (general.bdate) {
        f.general.bdate = general.bdate;
      }
      if (general.bstate) {
        f.general.bstate = general.bstate;
      }
      if (general.email) {
        f.general.email = general.email;
      }
      if (general.gender) {
        f.general.gender = general.gender;
      }
      if (general.gname) {
        f.general.gname = general.gname;
      }
      if (general.lname) {
        f.general.lname = general.lname;
      }
      if (general.slname) {
        f.general.slname = general.slname;
      }
      if (general.occupation) {
        f.general.occupation = general.occupation;
      }
      if (general.phone) {
        f.general.phone = general.phone;
      }
      if (general.populationid) {
        f.general.populationid = general.populationid;
      }
      if (general.taxid) {
        f.general.taxid = general.taxid;
      }
    }

    if (!f.general.phone) {
      setDisablePhone(true);
    } else {
      setDisablePhone(false);
    }

    if (!f.general.email) {
      setDisableMail(true);
    } else {
      setDisableMail(false);
    }

    if (!f.general.populationid) {
      setDisableCurpRfc(true);
    } else {
      setDisableCurpRfc(false);
    }

    setForm(JSON.parse(JSON.stringify(f)));
  };

  const changeCheck = () => {
    let f = form;
    if (!sameAddress) {
      f.address.invoicing = f.address.shipping;
    }
    setForm(JSON.parse(JSON.stringify(f)));
    setSameAddress(!sameAddress);
  };

  const changeTab = async (type) => {
    if (type == "shipping") {
      if (form.address.shipping.zip) {
        await getZip(type, form.address.shipping.zip);
      }
    }

    if (type == "invoicing") {
      if (form.address.invoicing.zip) {
        await getZip(type, form.address.invoicing.zip);
      }
    }
    setTab(type);
  };

  const changeGeneral = (key, e) => {
    let f = form;
    if (key == "bdate") {
      f.general.bdate = new Date(e.target.value).toISOString();
    } else {
      f.general[key] = e.target.value;
    }
    setForm(JSON.parse(JSON.stringify(f)));

    let v = validates;

    if (key == "phone") {
      setSend(false);
      setCodePhone("");
      v.phone.validate = false;
      if (!e.target.value) {
        setDisablePhone(true);
      } else {
        setDisablePhone(false);
      }
    }

    if (key == "email") {
      v.email.validate = false;
      if (!e.target.value) {
        setDisableMail(true);
      } else {
        setDisableMail(false);
      }
    }

    if (key == "populationid") {
      v.curp.validate = false;
      if (!e.target.value) {
        setDisableCurpRfc(true);
      } else {
        setDisableCurpRfc(false);
      }
    }

    if (key == "taxid") {
      v.rfc.validate = false;
    }

    let vg = verifyGeneral(f.general);
    let vi = verifyAddress(f.address.invoicing);
    let vs = verifyAddress(f.address.shipping);

    verifyButton(v, f.general.taxid, vg, vi, vs);
    setValidates(JSON.parse(JSON.stringify(v)));
  };

  const verifyAddress = (f) => {
    let flag = false;
    if ( f.country && f.extnum && f.locality && f.state && f.street && f.town && f.zip ) {
      flag = true;
    } else {
      flag = false;
    }
    return flag;
  };

  const verifyGeneral = (f) => {
    let flag = false;
    if ( f.bcountry && f.bdate && f.email && f.gender && f.gname && f.lname && f.occupation && f.phone && f.populationid ) {
      flag = true;
    } else {
      flag = false;
    }
    return flag;
  };

  const sendMessage = async (type) => {
    let v = validates;
    let f = form;
    props.changeLoader(true);
    setZPos(-1)

    if (type == "phone") {
      let send = {
        identity: {
          uuid: props.contentModal.uuid,
          phone: form.general.phone,
        },
        lead: {
          uuid: props.contentModal.uuid,
          general: form.general,
        },
      };

      let request = await API.service( "phoneAuthSend", send, props.pos, props.changeAlert, props.changeLoader, props.history );
      if (request.status == 200) {
        if (request.data.data.response == "OK") {
          v.phone.send = true;
          setSend(true);
          setToken(request.data.data.content);
        } else {
          v.phone.send = false;
          setSend(false);
          setToken("");
        }
      }
    }

    if (type == "email") {
      let send = {
        identity: {
          uuid: props.contentModal.uuid,
          email: form.general.email,
        },
        lead: {
          uuid: props.contentModal.uuid,
          general: form.general,
        },
      };
      let request = await API.service( "validateEmail", send, props.pos, props.changeAlert, props.changeLoader, props.history );
      if (request.status == 200) {
        if (request.data.data.response == "OK") {
          v.email.validate = true;
        } else {
          v.email.validate = false;
        }
      }
    }

    if (type == "curpRfc") {
      let send = {
        identity: {
          curp: form.general.populationid,
        },
        lead: {
          uuid: props.contentModal.uuid,
          general: form.general,
        },
      };

      if (form.general.taxid) {
        send.identity["rfc"] = form.general.taxid;
      }
      let request = await API.service( "validateCurpRfc", send, props.pos, props.changeAlert, props.changeLoader, props.history );
      if (request.status == 200) {
        if (request.data.data.response == "OK") {
          v.curp.validate = request.data.data.content.curp;
          if (form.general.taxid) {
            v.rfc.validate = request.data.data.content.rfc;
          }
        } else {
          v.curp.validate = false;
          v.rfc.validate = false;
        }
      }
    }
    let vg = verifyGeneral(f.general);
    let vi = verifyAddress(f.address.invoicing);
    let vs = verifyAddress(f.address.shipping);
    verifyButton(v, form.general.taxid, vg, vi, vs);
    setValidates(JSON.parse(JSON.stringify(v)));
    props.changeLoader(false);
    setZPos(45)
  };

  const sendVerify = async (type) => {
    props.changeLoader(true);
    setZPos(-1)

    let f = form;
    let v = validates;
    if (type == "phone") {
      let send = {
        identity: {
          uuid: props.contentModal.uuid,
          phone: form.general.phone,
          token: token,
          code: codePhone,
        },
      };

      let request = await API.service( "phoneAuthCheck", send, props.pos, props.changeAlert, props.changeLoader, props.history );
      if (request.status == 200) {
        if (request.data.data.response == "OK") {
          setSend(false);
          v.phone.validate = true;
        } else {
          setSend(true);
          v.phone.validate = false;
        }
      }
      setValidates(JSON.parse(JSON.stringify(v)));
    }

    let vg = verifyGeneral(f.general);
    let vi = verifyAddress(f.address.invoicing);
    let vs = verifyAddress(f.address.shipping);
    verifyButton(v, form.general.taxid, vg, vi, vs);
    props.changeLoader(false);
    setZPos(45)
  };

  const changeCodes = (type, e) => {
    if (type === "phone") {
      setCodePhone(e.target.value);
    }

    if (e.target.value.length !== 4) {
      setDisableSendCode(true);
    } else {
      setDisableSendCode(false);
    }
  };

  const verifyButton = (v, rfc, vg, vi, vs) => {
    if ( v.phone.validate && v.curp.validate && v.email.validate && vg && vi && vs ) {
      if (!rfc) {
        setDisabled(false);
      } else {
        if (v.rfc.validate) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }
    } else {
      setDisabled(true);
    }
  };

  const changeAddress = async (type, key, e) => {
    let v = validates;
    let f = form;
    f.address[type][key] = e.target.value;

    if (key == "zip") {
      if (e.target.value.length == 5) {
        await getZip(type, e.target.value, true);
      }
    }

    if (sameAddress) {
      f.address.invoicing = f.address.shipping;
    }
    let vg = verifyGeneral(f.general);
    let vi = verifyAddress(f.address.invoicing);
    let vs = verifyAddress(f.address.shipping);

    verifyButton(v, f.general.taxid, vg, vi, vs);
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const getZip = async (type, value, change = false) => {
    let f = form;
    props.changeLoader(true);
    setZPos(-1)

    if (type == "invoicing") {
      setLocalityInvoicing([]);
    }

    if (type == "shipping") {
      setLocalityShipping([]);
    }

    let data = {
      catalog: {
        id: "zip",
        filters: [{ key: value }],
      },
    };
    let request = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, props.history );
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        let cat = request.data.data.catalog;
        if (change && cat.length > 0) {
          f.address[type]["state"] = cat[0]["m"][0]["state_key"];
          f.address[type]["town"] = cat[0]["m"][0]["municipality"];
          setForm(JSON.parse(JSON.stringify(f)));
        }

        let cols = [];
        for (let i = 0; i < cat.length; i++) {
          cols.push(cat[i]["m"][0]["township"]);
        }
        if (type == "invoicing") {
          setLocalityInvoicing(cols);
        }
        if (type == "shipping") {
          setLocalityShipping(cols);
        }
      }
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const updateLead = async () => {
    let data = form;
    let lead = {
      lead: {
        uuid: props.contentModal.uuid,
        general: form.general,
        address: form.address,
      },
    };

    await props.updateLead(lead, closelightbox);
  };
  
  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          {props.rolEdit && tab === "verify" && "Verificar información"}
          {props.rolEdit && tab !== "verify" && "Editar información"}
          {!props.rolEdit && "Información"}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
					<Tabs value={0} >
            {props.rolEdit && <Tab label="Verificación" onClick={changeTab.bind(this, "verify")} id="tabOption" sx={{borderBottom: tab === "verify" ? "#3743aa solid 2px" : "none"}}/>}
						<Tab label="Información general" onClick={changeTab.bind(this, "general")} id="tabOption" sx={{borderBottom: tab === "general" ? "#3743aa solid 2px" : "none"}}/>
						<Tab label="Envío" onClick={changeTab.bind(this, "shipping")} id="tabOption" sx={{borderBottom: tab === "shipping" ? "#3743aa solid 2px" : "none"}}/>
						<Tab label="Facturación" onClick={changeTab.bind(this, "invoicing")} id="tabOption" sx={{borderBottom: tab === "invoicing" ? "#3743aa solid 2px" : "none"}}/>
					</Tabs>
				</Box>
        				
        <DialogContent>                
        {props.rolEdit && tab == "verify" &&
          <Grid container spacing={2} >
            <Grid item xs={6}>
              <TextField
                label="Teléfono" value={form.general.phone} onChange={changeGeneral.bind(this, "phone")}	size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <>
                <MATERIAL.Tooltip title="Enviar SMS">
                  <MATERIAL.IconButton onClick={sendMessage.bind(this, "phone")} disabled={disablePhone} color="primary" >
                    <ICONS.SendToMobile />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                {validates.phone.validate && (
                  <MATERIAL.Tooltip title="Validado">
                  <MATERIAL.IconButton color="primary">
                    <ICONS.CheckCircle />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                )}
              </>
            </Grid>
            {send && 
              <>
              <Grid item xs={6}>
                <TextField
                  label="Código" value={codePhone} onChange={changeCodes.bind(this, "phone")} size="small" fullWidth />
              </Grid>
              <Grid item xs={6}>
                <MATERIAL.Tooltip title="Enviar código">
                  <MATERIAL.IconButton color="primary" disabled={disableSendCode} onClick={sendVerify.bind(this, "phone")} >
                    <ICONS.Send />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
              </Grid>
              </>
            }
            <Grid item xs={6}>
              <TextField
                label="Email" value={form.general.email} onChange={changeGeneral.bind(this, "email")}	size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <>
                <MATERIAL.Tooltip title="Verificar email">
                  <MATERIAL.IconButton onClick={sendMessage.bind(this, "email")} disabled={disableMail} color="primary" >
                    <ICONS.Email />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                {validates.email.validate && (
                  <MATERIAL.Tooltip title="Validado">
                  <MATERIAL.IconButton color="primary">
                    <ICONS.CheckCircle />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                )}
              </>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="CURP" value={form.general.populationid} onChange={changeGeneral.bind(this, "populationid")} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <>
                <MATERIAL.Tooltip title={`Verificar CURP ${form.general.taxid ? "y RFC" : ""}`}>
                  <MATERIAL.IconButton onClick={sendMessage.bind(this, "curpRfc")} disabled={disableCurpRfc} color="primary" >
                    <ICONS.Send />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                {validates.curp.validate && (
                  <MATERIAL.Tooltip title="Validado">
                  <MATERIAL.IconButton color="primary">
                    <ICONS.CheckCircle />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                )}
              </>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="RFC" value={form.general.taxid} onChange={changeGeneral.bind(this, "taxid")} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <>
                {validates.rfc.validate && (
                  <MATERIAL.Tooltip title="Validado">
                  <MATERIAL.IconButton color="primary">
                    <ICONS.CheckCircle />
                  </MATERIAL.IconButton>
                </MATERIAL.Tooltip>
                )}
            </>
          </Grid>
        </Grid>
        }

        {tab === "general" && 
          <Grid container spacing={2} >
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              Datos Generales         
            </Grid>
            <Grid item xs={6}>
              <TextField label="Nombre(s)" value={form.general.gname} onChange={changeGeneral.bind(this, "gname")} disabled={!props.rolEdit} size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField label="Apellido paterno" value={form.general.lname} onChange={changeGeneral.bind(this, "lname")} disabled={!props.rolEdit} size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField label="Apellido materno" value={form.general.slname} onChange={changeGeneral.bind(this, "slname")} disabled={!props.rolEdit} size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Correo electrónico" value={form.general.email} onChange={changeGeneral.bind(this, "email")} disabled size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Fecha de Nacimiento"
                value={form.general["bdate"] ? new Date(form.general["bdate"]).toJSON().substr(0, 10) : form.general["bdate"]}
                disabled={!props.rolEdit} onChange={changeGeneral.bind(this, "bdate")}
                type={"date"}
                InputLabelProps={{ shrink: true }}								
                size="small" fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField label="CURP" value={form.general.populationid} onChange={changeGeneral.bind(this, "populationid")} disabled size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="País de Nacimiento" value={form.general.bcountry} onChange={changeGeneral.bind(this, "bcountry")} select disabled={!props.rolEdit} size="small" fullWidth >
                {props.catalogs.country?.map((item, index) => (
                  <MenuItem key={`country-general-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField label="RFC" value={form.general.taxid} onChange={changeGeneral.bind(this, "taxid")} disabled size="small" fullWidth/>
            </Grid>
            <Grid item xs={6}>
              <TextField  
                label="Ocupación" value={form.general.occupation} onChange={changeGeneral.bind(this, "occupation")} disabled={!props.rolEdit} select size="small" fullWidth >
                {props.catalogs.occupations?.map((item, index) => (
                  <MenuItem key={`occupation-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField  
                label="Género" value={form.general.gender} onChange={changeGeneral.bind(this, "gender")} select disabled={!props.rolEdit} size="small" fullWidth  >
                {props.catalogs.gender?.map((item, index) => (
                  <MenuItem key={`gender-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              <hr/>
              Documentos Personales: {identity.type}         
            </Grid>
            <Grid item xs={12}>
              Imagen Frontal:        
                <MATERIAL.IconButton color={identity?.front_image ? "success" : "error"}>
                  {identity?.front_image ? <ICONS.CheckCircle /> : <ICONS.Cancel />}
                </MATERIAL.IconButton>      
            </Grid>
            {identity?.type !== "" && identity?.type === "INE" &&
              <Grid item xs={12} style={{paddingTop: "0px"}}>
                Imagen Trasera:        
                <MATERIAL.IconButton color={identity?.back_image ? "success" : "error"}>
                  {identity?.back_image ? <ICONS.CheckCircle /> : <ICONS.Cancel />}
                </MATERIAL.IconButton>     
              </Grid>
            }
            <Grid item xs={12} style={{paddingTop: "0px"}}>
              Selfie:     
              <MATERIAL.IconButton color={identity?.token_face_image ? "success" : "error"}>
                {identity?.token_face_image ? <ICONS.CheckCircle /> : <ICONS.Cancel />}
              </MATERIAL.IconButton>     
            </Grid>
          </Grid>
        }

        {(tab === "shipping" || tab === "invoicing") &&
          <Grid container spacing={2} >
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              Dirección de {tab !== "invoicing" ? "Envío" : "Facturación"}
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="País" value={form.address[tab].country} onChange={changeAddress.bind(this, tab, "country")} select disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth >
                {props.catalogs.country?.map((item, index) => (
                  <MenuItem key={`country-${tab}-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Código Postal" value={form.address[tab].zip} onChange={changeAddress.bind(this, tab, "zip")} disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth inputProps={{ maxLength: 5}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Estado" value={form.address[tab].state} onChange={changeAddress.bind(this, tab, "state")} name="address.state" disabled select size="small" fullWidth >
                {props.catalogs.states.map((item, index) => (
                  <MenuItem key={`state-${tab}-${index}`} value={item.k}>{item.v}</MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Alcaldia / Municipio" value={form.address[tab].town} onChange={changeAddress.bind(this, tab, "town")} disabled size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Colonia" value={form.address[tab].locality} onChange={changeAddress.bind(this, tab, "locality")} select disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth >
                {tab === 'shipping' && localityShipping?.map((item, index) => (
                  <MenuItem key={`locality-${tab}-${index}`} value={item}>{item}</MenuItem>
                  ))}
                {tab === 'invoicing' && localityInvoicing?.map((item, index) => (
                  <MenuItem key={`locality-${tab}-${index}`} value={item}>{item}</MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Calle" value={form.address[tab].street} onChange={changeAddress.bind(this, tab, "street")} disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth inputProps={{ maxLength: 50 }}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="No. ext." value={form.address[tab].extnum} onChange={changeAddress.bind(this, tab, "extnum")} disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth inputProps={{ maxLength: 25 }}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="No. int." value={form.address[tab].intnum} onChange={changeAddress.bind(this, tab, "intnum")} disabled={tab !== "invoicing" ? !props.rolEdit : sameAddress || !props.rolEdit} size="small" fullWidth inputProps={{ maxLength: 25 }}/>
            </Grid>
            {tab !== "invoicing" &&
            <Grid item xs={12}>
              <FormControlLabel control={<Checkbox checked={sameAddress} onChange={changeCheck.bind(this)}/>} label={"Utilizar mismo domicilio en facturación"} disabled={!props.rolEdit} />
            </Grid>}
          </Grid>
        }
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={updateLead.bind(this)} >Editar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default LeadInfo;
